<template>
<div>
    <div class="pm-search-input">
        <input class="e-input" type="text" :placeholder='$t("Pm.searchByName")' v-model="searchString" maxlength="255"/>
    </div>

  <div class="h-scroll h100-80">
    <div class="col-lg-12 control-section">
      <div class="h-topo-tree">
        <ejs-treeview ref='leftTree'  :fields='searchFields' :nodeSelected='nodeSelected'></ejs-treeview>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { EventBus } from '../../../../../plugins/eventBus';

export default {
  name: 'left',
  components: {},
  data() {
    return {
      searchString: '',
      treeDataArray: [],
      initTree: [{ children: [] }],
      treeDatas: [{ children: [] }],
      fields: {},
      oldSearchString:'',
      leafNodeID: '',
    };
  },

  computed: {
    searchFields() {
      const This = this;
      const treeData = This.fields;
      const searchString = This.searchString.trim().toLowerCase();

       if (!searchString) {
        if(this.oldSearchString !==''){
          this.oldSearchString = searchString;
          this.sendNodeEmit(this.leafNodeID);
        }
        return treeData;
      }
      
      this.oldSearchString = searchString;

      let selectedData = [];
      selectedData = This.treeDataArray.filter(item => (item.neName.trim().toLowerCase().indexOf(searchString) !== -1));

      if (selectedData.length === 0) {
        selectedData = This.initTree;
      }

      return ({
        dataSource: selectedData,
        id: 'neId',
        text: 'neName',
        child: 'children',
      });
    }
  },

  methods: {
    nodeSelected(event) {
      // console.log('nodeSelected',event.nodeData)
      this.sendNodeEmit(event.nodeData.id);
    },
    sendNodeEmit(nodeId) {
      if (nodeId === '') {
        return;
      }
      const item = this.treeDataArray.filter(item => item.neId === nodeId);
      if (item[0].parentNeId === '0') {
        EventBus.$emit('toast', {type: 'warning', content:this.$t('Pm.pleaseSelectResource')});
      }
      this.$emit('nodeClicked', item[0]);
    },
    setTreeData(treeDataArray) {
      this.treeDatas = treeDataArray
        .filter(item => item.parentNeId === '0')
        .map(item => {
          const { neId, neName } = item;
          return {
            neId,
            neName,
            children: [],
          };
        });
      for (const node of this.treeDatas) {
        let children = [];
        children = treeDataArray.filter(item => {
          if (item.parentNeId === node.neId) {
            return item;
          }
        })

        node.children = children;
      }
    }
  },

  mounted() {
    const This = this;
    This.$axios.post('/lte/pm/kpichart/getEamTree.html?systemId=1').then(response => {
      if (response.status !== 200 || response.data === undefined) {
        return;
      }
      if (response.data.errorCode === 'SUCCESS') {
        This.treeDataArray = response.data.resultVal;       
        this.setTreeData(This.treeDataArray);

        this.leafNodeID = '';
        let isGet = false;
        for (const item of this.treeDatas) {
          for (let children of item.children) {
            children.selected = true;
            this.leafNodeID = children.neId;
            isGet = true;
            break;
          }
          if (isGet) {
            break;
          }
        }
        this.sendNodeEmit(this.leafNodeID);

        This.fields = {
          dataSource: This.treeDatas,
          id: 'neId',
          text: 'neName',
          child: 'children',
          selected: 'selected',
          expanded: 'neName',
          tooltip: 'neName',
        };
      } else {
        console.log('error', response.data.errorCode);
      }
    }).catch((error) => { // 请求失败处理
      console.log('error', error);
    });
  }

};
</script>
